module.exports = __webpack_public_path__ + "static/Donate_Team-1065309ca26714d4757f73cc6c5df715.png";